export default function subscriptionsPage(config) {
    return {
        annual: config.userBillingPeriod === 'annual',
        loading: false,
        loadingProductId: null,
        products: config.products || [],
        userProductId: config.userProductId,
        userBillingPeriod: config.userBillingPeriod || null,
        enterpriseLocked: config.enterpriseLocked || false,
        isLegacyUser: config.isLegacyUser || false,
        subscriptionCancelled: config.subscriptionCancelled || false,
        email: config.email,
        loginToken: config.loginToken,
        amemberPluginUrl: config.amemberPluginUrl,
        amemberBaseUrl: config.amemberBaseUrl,
        canManageBilling: config.canManageBilling || false,
        cancelling: false,
        invoicesOpen: false,
        changePlanOpen: false,

        init() {
            // enterprise users have no toggle — keep annual fixed to their billing period
            if (this.enterpriseLocked) {
                this.annual = this.userBillingPeriod === 'annual';
            }
        },

        isActiveProduct(productId) {
            if (this.subscriptionCancelled) return false;
            if (this.userProductId != productId) return false;
            // only active if viewing the same billing period
            if (this.userBillingPeriod === 'annual') return this.annual;
            if (this.userBillingPeriod === 'monthly') return !this.annual;
            return true;
        },

        hasUpgrade(productId) {
            const product = this.products.find(p => p.id == productId);
            if (!product || !product.upgrades) return false;

            for (const upgrade of product.upgrades) {
                if (upgrade.annual === this.annual) return true;
            }
            return false;
        },

        getUpgrade(productId) {
            const product = this.products.find(p => p.id == productId);
            if (!product || !product.upgrades) return null;

            for (const upgrade of product.upgrades) {
                if (upgrade.annual === this.annual) return upgrade;
            }
            return null;
        },

        async selectPlan(productId) {
            if (!this.canManageBilling) {
                Alpine.store('toast').show('Only the account owner can change the subscription plan.', 'error');
                return;
            }

            this.loading = true;
            this.loadingProductId = productId;

            try {
                // 1. Authenticate with aMember via cdt-api/login
                const loginUrl = `${this.amemberPluginUrl}cdt-api/login?email=${encodeURIComponent(this.email)}&login_token=${encodeURIComponent(this.loginToken)}`;
                const loginRes = await fetch(loginUrl);
                const loginJson = await loginRes.json();

                if (!loginJson.success) {
                    Alpine.store('toast').show('Authentication failed. Please try again.', 'error');
                    this.loading = false;
                    this.loadingProductId = null;
                    return;
                }

                // 2. Check if this is an upgrade or new subscription
                const upgrade = this.getUpgrade(productId);
                const product = this.products.find(p => p.id == productId);

                const darkMode = document.documentElement.dataset.theme === 'business' ? 'dark' : 'light';

                if (upgrade) {
                    // Upgrade existing subscription
                    this.invisibleFormPost(`${this.amemberBaseUrl}member/upgrade`, {
                        email: this.email,
                        loginToken: this.loginToken,
                        upgrade: upgrade.product_upgrade_id,
                        invoice_id: upgrade.invoice_id,
                        invoice_item_id: upgrade.invoice_item_id,
                        darkMode
                    });
                } else {
                    // New subscription
                    const planSlug = `${product.title.toLowerCase()}-${this.annual ? 'annual' : 'monthly'}`;
                    this.invisibleFormPost(`${this.amemberPluginUrl}cdt-api/new-subscription`, {
                        email: this.email,
                        loginToken: this.loginToken,
                        'redirect-url': `${this.amemberBaseUrl}buy/${planSlug}`,
                        darkMode
                    });
                }
            } catch (e) {
                console.error('Plan selection failed:', e);
                Alpine.store('toast').show('Something went wrong. Please try again.', 'error');
                this.loading = false;
                this.loadingProductId = null;
            }
        },

        invisibleFormPost(url, data) {
            const form = document.createElement('form');
            form.target = '_self';
            form.method = 'POST';
            form.action = url;
            form.style.display = 'none';

            for (const key in data) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
            }

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },

        async cancelSubscription() {
            if (!this.canManageBilling) {
                return;
            }

            let leavingPage = false;

            const confirmed = await Alpine.store('confirmModal').open(
                'Cancel subscription',
                'You will keep access until the paid period ends.',
                {
                    keepOpenOnConfirm: true,
                    confirmText: 'Cancel plan',
                    confirmClass: 'btn-error',
                }
            );

            if (!confirmed) return;

            this.cancelling = true;

            try {
                const res = await fetch('/subscription/cancel', {
                    method: 'POST',
                    headers: {'Accept': 'application/json'},
                });
                const json = await res.json();

                if (json.success) {
                    Alpine.store('toast').show('Subscription cancelled.', 'success');
                    leavingPage = true;
                    window.location.reload();
                    return;
                }

                if (json.redirect) {
                    leavingPage = true;
                    window.location.href = json.redirect;
                    return;
                }

                Alpine.store('toast').show(json.error || 'Unable to cancel subscription.', 'error');
            } catch (e) {
                console.error('Cancel subscription failed:', e);
                Alpine.store('toast').show('Unable to cancel subscription.', 'error');
            } finally {
                this.cancelling = false;
                if (!leavingPage) Alpine.store('confirmModal').loading = false;
            }
        },

    };

}
